module.exports = "<div class=\"details\">\n  <img  class=\"ba_im\" src={{image}} />\n</div>\n"